import mapKeys from 'lodash/mapKeys';

export const capitalizeKeys = <T>(obj: object) => {
  return mapKeys(obj, (value, key) => {
    return `${key}`.charAt(0).toUpperCase() + key.slice(1);
  }) as T;
};
